/**
* Component MainTitle
*
* Display a main title, a subtitle, an optional anchor text
*
* Props : 
* - anchor (String) : optional text display at the top of the main title
* - title (String) : main title 
* - subtitle (String) : text display bot of the main title. "v-html" allows you to include tage, for example to have several paragraph
* - background (String) : Define color of props "title". By default the color is black
*
* Method : 
* - backougrndClass (computed) : return class css "title_black" if the value of "background" is black or default. Otherwise apply "title_blue"
*/

<template>
  <div data-aos="fade" data-aos-duration="1000" data-aos-easing="ease-in-out"  data-aos-once="true">
  <p class="maintitle_anchor" v-if="anchor" >{{ anchor }} </p>
    <h1 class="maintitle_title" :class="backgroundClass" > {{ title }} </h1>
    <p class="maintitle_keyword" v-html="keyword"> </p>
    <p class="maintitle_subtitle" v-html="subtitle"></p>
  </div>
 </template>
 
 <script>
 export default {
   name: 'MainTitle',
   props:{
    anchor:String,
    title:String,
    keyword:String,
    subtitle:String,
    background:{
      type:String,
      default:"black"
    },
   },
    computed: {
    backgroundClass() {
      return this.background === "black" ? "maintitle_title_black" : "maintitle_title_blue";
    },
  },
}
</script>

 <style lang="scss">
 @import "../assets/styles/_variables.scss";

 .maintitle_anchor {
  position: relative; 
  color: $third-color;
}
 .maintitle_title_blue{
  color:$second-color
 }

 .maintitle_keyword{
  font-style: italic;
  margin-top: -0.5rem;
 }

  /* Display a line before the anchor */
.maintitle_anchor::before {
  content: ""; 
  position: absolute;
  left: 0;
  top: -20%; 
  transform: translateY(-50%); 
  width: 1.8rem; 
  height: 1px;
  background-color: $third-color;
}

/* Not show the line if anchor is empty */
.maintitle_anchor:empty::before {
  display: none;
}
 </style>